import React, { CSSProperties } from 'react';

import { NEUTRAL_2 } from '@/colors/colors';

import { stySkeletonLoading } from './style';

function SkeletonLoading({
  className,
  color,
  height,
  width,
  style,
}: {
  className?: string;
  color?: string;
  height?: string | number;
  width?: string | number;
  style?: CSSProperties;
}) {
  return (
    <div
      data-testid="skeleton-loading"
      className={`${stySkeletonLoading({ color, height, width })} ${className}`}
      style={style}
    />
  );
}

SkeletonLoading.defaultProps = {
  color: NEUTRAL_2,
  className: '',
  style: {},
  height: '100%',
  width: '100%',
};

export default SkeletonLoading;
